import { createCommand } from '../../utils';
import { InitReferenceCommand } from './InitReferenceCommand';
import { latestReferenceGenerationQuery } from '../queries';
import { generationsLoaded, moduleName } from '../state';

/**
 * Loads the organization's latest generations. When the generation we were waiting for has just
 * finished, the sections it added are loaded too, so they appear without a page reload.
 */
export const LoadReferenceGenerationsCommand = createCommand(
    `${moduleName}/LOAD_REFERENCE_GENERATIONS`,
    async (_, { dispatch, extra, getState }) => {
        const before = latestReferenceGenerationQuery(getState());
        const generations = await extra.externalReference.loadReferenceGenerations();
        dispatch(generationsLoaded(generations));

        const after = latestReferenceGenerationQuery(getState());
        if (before?.status === 'running' && after?.id === before.id && after.status === 'done') {
            await dispatch(InitReferenceCommand());
        }
    },
);
